// router/index.js
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
    meta:{
      requiresAuth: false,
      layout: "Login"
    }
  },
  {
    path: '/MyProfile',
    name: 'MyProfile',
    component: () => import('../views/MyProfilePage.vue'),
    meta:{
      requiresAuth: false,
      layout: "Default"
    }
  },
  {
    path: '/MyProfile/updatePhone',
    name: 'MyProfileUpdatePhone',
    component: () => import('../views/MyProfileUpdatePhonePage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },  
  {
    path: '/Setting',
    name: 'Setting',
    component: () => import('../views/SettingPage.vue'),
    meta:{
      requiresAuth: false,
      layout: "Default"
    }
  }, 
  
  {
    path: '/MyEvents',
    name: 'EventListPage',
    component: () => import('../views/ProductListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/MyEvents/list/:status',
    name: 'EventDraftListPage',
    component: () => import('../views/EventDraftListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },    
  {
    path: '/MyEvents/:id',
    name: 'WorkshopixProductView',
    component: () => import('../views/ProductViewPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/MyEvents/add',
    name: 'eventAddForm',
    component: () => import('../views/eventAddFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  }, 
  {
    path: '/MyEvents/update/:id/general',
    name: 'eventUpdateGeneralForm',
    component: () => import('../views/eventUpdateGeneralFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  }, 
  {
    path: '/MyEvents/update/:id/detail',
    name: 'eventUpdateDetailForm',
    component: () => import('../views/eventUpdateDetailFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  }, 
  {
    path: '/MyEvents/update/:id/links',
    name: 'eventUpdateLinksForm',
    component: () => import('../views/eventUpdateLinksFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  }, 
  {
    path: '/MyEvents/update/:id/images',
    name: 'eventUpdateImagesForm',
    component: () => import('../views/eventUpdateImagesFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  },  
  {
    path: '/MyEvents/update/:id/confirm',
    name: 'eventUpdateConfirmForm',
    component: () => import('../views/eventUpdateConfirmFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Event"
    }
  },   
  {
    path: '/Message',
    name: 'MessageList',
    component: () => import('../views/MessageListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/Message/:id',
    name: 'MessageView',
    component: () => import('../views/MessageViewPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/MessageTemplate',
    name: 'MessageTemplateList',
    component: () => import('../views/MessageTemplateListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/BulkMessage',
    name: 'BulkMessageList',
    component: () => import('../views/BulkMessageListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/BulkMessage/:id',
    name: 'BulkMessageView',
    component: () => import('../views/BulkMessageViewPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/Order',
    name: 'OrderList',
    component: () => import('../views/OrderListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/Order/all',
    name: 'OrderAll',
    component: () => import('../views/OrderListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },
  {
    path: '/Banner',
    name: 'Banner',
    component: () => import('../views/BannerListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/Writer',
    name: 'WriterList',
    component: () => import('../views/WriterListPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  }, 
  {
    path: '/Writer/update/:id',
    name: 'WriterUpdateForm',
    component: () => import('../views/WriterUpdateFormPage.vue'),
    meta: {
      requiresAuth: true,
      layout: "Default"
    }
  },  
  {
    path :'/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      requiresAuth: false,
      layout: "NotFound"
    }    
  }
];

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "active",
});

router.beforeEach((to, from, next)=> {
  to;from;next;
  let token = localStorage.getItem("access_token") ?? "";
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (token!="") {      
      next();
    } else {
      next({name:'Login'});
    }
  }
  else{
    next(); 
  }
});

export default router;